import type { PropsWithChildren, ReactNode } from 'react';

export function Button({ children, variant = 'primary', ...props }: PropsWithChildren<React.ButtonHTMLAttributes<HTMLButtonElement> & { variant?: 'primary' | 'secondary' | 'danger' }>) {
  return <button className={`button ${variant}`} {...props}>{children}</button>;
}

export function Card({ title, eyebrow, action, children }: PropsWithChildren<{ title?: string; eyebrow?: string; action?: ReactNode }>) {
  return <section className="card">
    {(title || action) && <header className="card-header"><div>{eyebrow && <p className="eyebrow">{eyebrow}</p>}{title && <h2>{title}</h2>}</div>{action}</header>}
    {children}
  </section>;
}

export function Empty({ children }: PropsWithChildren) {
  return <div className="empty"><span aria-hidden="true">✦</span><p>{children}</p></div>;
}

export function StatusPill({ status }: { status: string }) {
  const labels: Record<string, string> = { active: '正常', disabled: '已停用', completed: '已完结', frozen: '已冻结', visible: '可见', hidden: '已隐藏' };
  return <span className={`status ${status}`}>{labels[status] ?? status}</span>;
}

export function Loading() {
  return <div className="loading" role="status"><span /><p>正在翻开故事页…</p></div>;
}
